import { Card, CardContent, Grid, Icon, Typography} from '@mui/material';
import React from 'react'
import { CreditCard, Filter, Search, TrendingUp, User } from 'react-feather';
import { AllowedAccess } from 'react-permission-role';
import { useLocation, useParams } from 'react-router-dom';
// import { FilterPayments } from './PaymentsFilter/FilterPayments';
import { useFechInitVehicleCredits } from './hooks';
import { VehiclesCreditsTable } from './VehiclesCreditsTable/VehiclesCreditsTable';
import { VehicleCreditForm } from './VehicleForm/VehicleForm';
import { LinearLoading } from 'common';
// import { ModalModule } from './Modal';

export const VehiclesCredits = () => {

  const location = useLocation();
  const paramsURL = useParams();
  const useFetchInit = useFechInitVehicleCredits({location, paramsURL})

  const { globalStates: { showForm }, FetchData } = useFetchInit

  const { fetchAllVehicleCredits: { loadingFetchVehicleCredits } } = FetchData

  return (
    <AllowedAccess permissions={['204_VEHICULOS_CREDITOS']} renderAuthFailed={<p>Error</p>}>
      <div className='content'>
      {(!showForm)&&(
        <div className='panel-body' id='listadoregistros'>
          <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{mb: 5}}>
              <Card>
                <CardContent>
                  {/* <ModalModule useFetchInit={useFetchInit} /> */}

                  <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt:1, mb:3}}>
                    <Typography variant='h4' sx={{ display: 'flex', alignItems: 'center' }}>
                      Credito de Vehiculos
                      <Icon component={TrendingUp} sx={{ ml: 1, fontSize: '1.5rem' }} />
                    </Typography>
                  </Grid>
                  {loadingFetchVehicleCredits && <LinearLoading />}
                  <VehiclesCreditsTable useFetchInit={useFetchInit}/>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>
        )}
        {(showForm) && (
          <>
              <div className='panel-body' id='formularioregistros'>
                  <VehicleCreditForm 
                      useFetchInit={useFetchInit}
                  />
              </div>
          </>
        )}
      </div>
    </AllowedAccess>
  )
}
